// extracted by mini-css-extract-plugin
export var cardLayout = "_7e-1";
export var paginationContainer = "_7e-0";